import { render, staticRenderFns } from "./checklistScenarioCopy.vue?vue&type=template&id=b04271a0"
import script from "./checklistScenarioCopy.vue?vue&type=script&lang=js"
export * from "./checklistScenarioCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b04271a0')) {
      api.createRecord('b04271a0', component.options)
    } else {
      api.reload('b04271a0', component.options)
    }
    module.hot.accept("./checklistScenarioCopy.vue?vue&type=template&id=b04271a0", function () {
      api.rerender('b04271a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/checklist/action/checklistScenarioCopy.vue"
export default component.exports